import React from "react";
import SearchResult from "./SearchResult";
import NoSearchResults from "../NoResultFound";

function VideoListingComponent({ listing = [], videoCount = 0 }) {
  return Array.isArray(listing) && videoCount == 0 ? (
    <NoSearchResults />
  ) : (
    listing.map((value, index) => <SearchResult listing={value} key={index} />)
  );
}

export { VideoListingComponent };
